var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.html",value:({
        title: _vm.info,
    }),expression:"{\n        title: info,\n    }",modifiers:{"hover":true,"html":true}}],staticClass:"text-muted"},[_c('i',{staticClass:"fas fa-info-circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }